<template>
    <div class="title1">
        <P style="font-size: 20px">主变电负荷电流变化</P>
        <div class="title-info"><div class="scale">Load current change of main transformer</div></div>
    </div>
    <div class="box" id="customerChart"></div>
</template>

<script>
    import {optionone} from '../../../public/js/echarts'
    import {EleResize} from '../../../public/js/esresize'
    import {onMounted} from 'vue';
    import * as echarts from 'echarts'
    export default {
        name: "load",
        setup(){
            onMounted(()=>{
                const drawLine = ()=>{
                    let option = optionone();
                    let myChart = echarts.init(document.getElementById("customerChart"));
                    myChart.setOption(option);
                    let listener = function() {
                        myChart.resize();
                    };
                    EleResize.on(document.getElementById("customerChart"), listener);
                };
                drawLine();
            })

        }
    }
</script>

<style scoped lang="less">
    @import "./../../assets/canshu";
    .title-info{
      .scale{
          width: 100%;
          height: 100%;
          transform: scale(0.5);
          font-size: 16px;
          position: absolute;
          white-space: nowrap;
          left: -20%;
      }
    }
    .box{
        background: url("./../../assets/load-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 363px;
        height: 216vh*@vh;
        margin-top: 26vh*@vh;
    }
</style>